import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var SlugifyPipe = (function () {
    function SlugifyPipe() {
    }
    SlugifyPipe.prototype.transform = function (str) {
        return isString(str)
            ? str.toLowerCase().trim()
                .replace(/[^\w\-]+/g, ' ')
                .replace(/\s+/g, '-')
            : str;
    };
    return SlugifyPipe;
}());
export { SlugifyPipe };
SlugifyPipe.decorators = [
    { type: Pipe, args: [{ name: 'slugify' },] },
];
/** @nocollapse */
SlugifyPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=slugify.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/slugify.js
// module id = 267
// module chunks = 4